//@ts-nocheck - window.rdt events are not typed
const redditPixelEvents = {
    signup: () => window.rdt?.('track', 'SignUp'),
    subscribe: () => window.rdt?.('track', 'Purchase'),
    addToCart: () => window.rdt?.('track', 'AddToCart'),
};

export default redditPixelEvents;
